import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'

const TopNavBackground = styled.div`
    color: ${props => props.theme.font_light};
    z-index: 999;
    position: fixed;
    top: 0;
    height: 3rem;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    background-color: ${props => props.background 
        ? props.inverse ? props.theme.bg_light : props.theme.bg_dark 
        : 'rgba(0,0,0,0)'
    };
    transition: background-color 0.25s ease;
`
const TopNav = styled.div`
    margin: 0 0.5rem;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 60em;
    font-family: ${props => props.theme.font_body};

    h1, h2, h3, h4, h5, h6 {
        font-family: ${props => props.theme.font_header};
        margin-right: auto;
        a {
            display: block !important;
            font-size: 1.2rem;
        }
        @media screen and (max-width: 980px) {
            font-size: 1rem;        
        }
    }
    a {
        cursor: pointer;
        font-size: 0.75em;
        color: ${props => props.dark
            ? props.theme.font_dark
            : props.theme.font_light};
        border-bottom: none;
        padding: 0.5em 0.75em 0 0.75em;
        margin-bottom: .25em; 
        text-decoration: none;
        display: block;
        transition: 0.3s;
        &:hover{
            color: ${props => props.underline
                ? props.dark
                    ? props.theme.font_dark
                    : props.theme.font_light
                : props.theme.accent};
            border-bottom: ${ props => props.underline
                ? '3px solid'
                : 'none'} !important;
        }
        @media screen and (max-width: 980px) {
            display: none;
        }
    }
`
const SideNav = styled.div`
    height: 100%; 
    width: 0; /* Change width in Javascript to make this slide in and out. */
    position: fixed; 
    z-index: 100; 
    top: 0;
    left: 0;
    background-color: ${props => props.theme.bg_dark };
    overflow-x: hidden; /* Disable horizontal scroll */
    padding-top: 60px; 
    transition: 0.5s;
    ul {
        list-style: none;
    }
    a {
        color: ${props => props.theme.font_light};
        border-bottom: none !important;
        padding: 0.5em 0.25em 0.5em 0.25em; 
        text-decoration: none;
        font-size: 25px;
        display: block;
        transition: 0.3s;
        a:hover{
            color: ${props => props.theme.accent};
        }
        @media screen and (max-height: 450px) {
            font-size: 1.25em;
        }
    }
    @media screen and (max-height: 450px) {
        padding-top: 15px;
    }
`
const SideNavDimmer = styled.div`
    position: fixed;
    height: 100%;
    width: 100%;
    background-color: black;
    opacity: 0.75;
    z-index: 99;
    top: 0;
    left: 0;
    animation: fadein .5s;
    @keyframes fadein {
        from    {opacity: 0}
        to      {opacity: 0.75}
    }
`
const Glyph = styled.span`
    cursor: pointer; 
    font-family: FontAwesome;
    font-size: 1.25rem;
    text-decoration: none;
    border-bottom: none !important;
`
const SideNavCloseButton = styled.a`
    cursor: pointer; 
    position: absolute;
    top: 0;
    right: 25px;
    font-size: 16px;
    margin-left: 50px;   
`
const SideNavBars = styled.a`
    cursor: pointer; 
    margin-left: 50px;   
    display: none !important;
    @media screen and (max-width: 980px) {
        display: block !important;
    }
`

class Navbar extends React.Component {
    state = { open: false }
    onClick = () => this.setState({ open: !this.state.open }) 
    componentDidMount () {
        window.addEventListener('scroll', this.handleScroll)
    }
    componentWillUnmount () {
        window.removeEventListener('scroll', this.handleScroll)
    } 
    handleScroll = () => {
        const position = document.body.scrollTop || document.documentElement.scrollTop
        this.setState({ position })
    }
    render () {
        const navWidth = this.state.open ? '75vw' : '0px'
        const navBackground = this.state.position > 0 || !this.props.fade ? true : false
        return (
            <TopNavBackground id='topnav' inverse={this.props.inverse} dark={this.props.dark} background={navBackground}>
                <TopNav {...this.props}>
                    {this.props.children}
                    <SideNavBars onClick={this.onClick}><Glyph className='fas fa-bars'/></SideNavBars>
                </TopNav>
                <SideNav style={{ width: navWidth }}>
                    <SideNavCloseButton onClick={this.onClick}><Glyph className='fas fa-arrow-left'/></SideNavCloseButton> 
                    <ul>
                        {this.props.children.map((link, index) => <li key={'list_'+index} onClick={this.onClick}>{link}</li>)}
                    </ul>
                </SideNav>
                {this.state.open && <SideNavDimmer onClick={this.onClick}/>}
            </TopNavBackground>
        )
    }
}

export { Navbar }


// WEBPACK FOOTER //
// ./src/components/navbar.js